import React, { useEffect, useState, useMemo } from "react";
   import { Link } from 'react-router-dom';

   import "./Homepage.css";

   
   /* ---------------------------------------------------------------------------
      1.  Service data (images live in /public/images/)
      --------------------------------------------------------------------------- */
   const SERVICES = [
    {
      key: "dataRewards",
      label: "Bulk Data",
      category: "MOBILE DATA REWARDS",
      headline: [
        "Reward your customers",
        "with data and watch",
        "engagement soar!",
      ],
      bullets: [
        "Offer mobile data incentives for sign-ups, referrals, purchases, or loyalty programs",
        "Drive user activity on apps, websites, and digital platforms",
      ],
      mediaType: "video",
      media: "/images/peak-video.mp4",
      poster: "/images/thumbnail.jpeg",
      link: "/bulk-data",
    },
     {
      key: "bulkSms",
      label: "Bulk SMS",
      category: "BULK SMS",
      headline: ["Reach your audience instantly with", "personalised messages!"],
      bullets: [
        "Send promotions, alerts, and OTP notifications to thousands in seconds.",
        "Use targeted messaging for maximum impact.",
      ],
      img: "/images/sms-service.jpg",
      link: "/bulk-sms",
    },
     {
       key: "airtime",
       label: "Bulk Airtime",
       category: "AIRTIME REWARDS",
       headline: ["Boost customer engagement", "with instant airtime rewards."],
       bullets: [
         "Provide airtime top-ups as incentives for purchases, surveys, or promotions.",
         "Customize rewards based on user behavior and engagement",
       ],
       img: "/images/airtime-service.jpg",
       link: "/airtime-rewards",
     },
     {
       key: "zeroRating",
       label: "Sponsored Data",
       category: "SPONSORED DATA",
       headline: ["Let your customers browse your", "app or website for free!"],
       bullets: [
         "Cover browsing costs for your users, making your platform Data-Free.",
         "Eliminate Internet barriers for higher engagement and retention.",
       ],
       img: "/images/sponsored-service.jpg",
     },
      {
        key: "whatsAppMarketing",
        label: "WhatsApp Marketing",
        category: "WHATSAPP MARKETING",
        headline: ["Drive engagement with bulk WhatsApp ", "messaging."],
        bullets: [
          "Deliver promotions, notifications, reminders, and support messages directly on WhatsApp.",
          "Use rich media and real-time conversations to create faster, more effective customer journeys.",
        ],
        img: "/images/whatsapp-service.jpg",
      },
      {
        key: "loyalty",
        label: "Loyalty",
        category: "PEAK LOYALTY",
        headline: ["Reward customers and grow", "lasting brand loyalty."],
        bullets: [
          "Reward every transaction and give customers flexible ways to earn and redeem points.",
          "Use real-time analytics and segmentation to run smarter campaigns and increase repeat purchases.",
        ],
        img: "/images/loyalty.jpg",
        link: "https://mypoints.peakmobile.co.ke/",
        external: true,
      },
   ];

   


   
   /* ---------------------------------------------------------------------------
      2.  Component
      --------------------------------------------------------------------------- */
   const Homepage = () => {
     /* ----- picker state ----- */
     const [activeKey, setActiveKey] = useState(SERVICES[0].key);
     const activeService = SERVICES.find((s) => s.key === activeKey);

        const heroSlides = [
          {
            img: "/images/new-3.jpg",
            title: "Reach your audience",
            title2: "with personalised messages!",
            subtitle: "Send promotions, alerts and OTP notifications",
            subtitle2: "in seconds",
            titleStyle: { color: "#FF6A00" },
            subtitleStyle: { color: "#FFFFFF" },
            position: { left: "10%", textAlign: "left" },
          },
          {
            img: "/images/new-1.jpg",
            title: "Reward your customers",
            title2: "with data",
            subtitle: "Drive engagement and user activity online",
            titleStyle: { color: "#FF6A00" },
            subtitleStyle: { color: "#000" },
            position: { left: "10%", textAlign: "left" },
          },
          {
            img: "/images/new-2.jpg",
            title: "Provide airtime rewards",
            title2: "as incentives",
            subtitle: "Make purchases, surveys or promotions worth it",
            titleStyle: { color: "#FFFFFF" },
            subtitleStyle: { color: "#FFFFFF" },
            position: { right: "10%", textAlign: "right" },
          },

        ];
        
        const [currentIndex, setCurrentIndex] = useState(0);
        
        useEffect(() => {
          const iv = setInterval(() => {
            setCurrentIndex((i) => (i + 1) % heroSlides.length);
          }, 5000);
          return () => clearInterval(iv);
        }, [heroSlides.length]);

        const rotatingWords = useMemo(
          () => ["Rewards", "Engagement", "Reach", "Growth"],
          []
        );
        const [wordIndex, setWordIndex] = useState(0);
        const [charIndex, setCharIndex] = useState(0);
        const [displayedText, setDisplayedText] = useState("");
        const [isDeleting, setIsDeleting] = useState(false);
      
        useEffect(() => {
          const currentWord = rotatingWords[wordIndex];
          const isTyping = !isDeleting;
      
          if (isTyping && charIndex <= currentWord.length) {
            const timeout = setTimeout(() => {
              setDisplayedText(currentWord.substring(0, charIndex));
              setCharIndex((prev) => prev + 1);
            }, 75); // typing speed
      
            return () => clearTimeout(timeout);
          }
      
          if (!isTyping && charIndex >= 0) {
            const timeout = setTimeout(() => {
              setDisplayedText(currentWord.substring(0, charIndex));
              setCharIndex((prev) => prev - 1);
            }, 60); // deleting speed
      
            return () => clearTimeout(timeout);
          }
      
          if (isTyping && charIndex > currentWord.length) {
            const pauseBeforeDelete = setTimeout(() => {
              setIsDeleting(true);
            }, 1300);
            return () => clearTimeout(pauseBeforeDelete);
          }
      
          if (!isTyping && charIndex < 0) {
            setIsDeleting(false);
            setWordIndex((prev) => (prev + 1) % rotatingWords.length);
            setCharIndex(0);
          }
        }, [charIndex, wordIndex, isDeleting, rotatingWords]);

   
     return (
       <div className="homepage">
         {/* ===============================================================
            Hackathon Banner
         =============================================================== */}
         {/* <div className="hackathon-banner">
           <div className="hackathon-content">
             <span className="hackathon-text">
               Join our upcoming Hackathon! Register now and innovate with us.
             </span>
             <a 
               href="https://docs.google.com/forms/d/e/1FAIpQLSexLbCzr0zoTZ5WEg73Hq-7hRxsHrtv_CfWP2Jx95FMTb0gAA/viewform?pli=1" 
               className="hackathon-link"
               target="_blank"
               rel="noopener noreferrer"
             >
               Register Here →
             </a>
           </div>
         </div> */}

         {/* ===============================================================
            Hero
         =============================================================== */}
        <section className="hero-section-home">
          <div className="hero-content-home">
            <div className="hero-title-home">
              <div className="header-img">
                <img src="/images/arrow.svg" alt="Arrow icon" style={{width:"90px"}} />

              </div>
              <h1>
              Amplify Your{" "}
              <span className="animated-word">{displayedText}</span>
            </h1>
            </div>
            <p>
              Our customer engagement tools are designed to delight your customer
              and benefit your bottom line.
            </p>
            <br></br>
            <div className="hero-buttons">

              <Link to="/book-demo" className="primary-button">
              Book a Demo
            </Link>

              
            </div>
          </div>
          <div
              className="hero-image"
              style={{ position: "relative", overflow: "hidden" }}
            >
              <img
                src={heroSlides[currentIndex].img}
                alt={`Slide ${currentIndex + 1}`}
                style={{ width: "100%", display: "block" }}
              />
              <div
                className="overlay"
                style={{
                  position: "absolute",
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: "40%",
                  ...heroSlides[currentIndex].position,
                }}
              >
                <h2
                  style={{
                    margin: 0,
                    fontSize: "2.5rem",
                    lineHeight: 1.2,
                    fontWeight: "bold",
                    ...heroSlides[currentIndex].titleStyle,
                  }}
                >
                  {heroSlides[currentIndex].title}
                </h2>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "2.5rem",
                    lineHeight: 1.2,
                    fontWeight: "bold",
                    ...heroSlides[currentIndex].titleStyle,
                  }}
                >
                  {heroSlides[currentIndex].title2}
                </h2>
                <p
                  style={{
                    marginTop: "0.5rem",
                    fontSize: "1.125rem",
                    ...heroSlides[currentIndex].subtitleStyle,
                  }}
                >
                  {heroSlides[currentIndex].subtitle}
                </p>
                <p
                  style={{
                    fontSize: "1.125rem",
                    ...heroSlides[currentIndex].subtitleStyle,
                  }}
                >
                  {heroSlides[currentIndex].subtitle2}
                </p>
              </div>

              <style>
                {`
                  .hero-image .overlay h2 {
                    font-size: 2.5rem;
                  }
                  .hero-image .overlay p {
                    font-size: 1.125rem;
                  }
                  @media (max-width: 640px) {
                    .hero-image .overlay {
                      width: 80% !important;
                    }
                    .hero-image .overlay h2 {
                      font-size: .9rem !important;
                    }
                    .hero-image .overlay p {
                      font-size: 0.5rem !important;
                    }
                  }
                `}
              </style>
            </div>


        </section>

   
         {/* ===============================================================
            Mission
         =============================================================== */}
         <section className="mission-section">
           <h2>What We Do</h2>
           <p>
           We offer mobile marketing solutions that make acquisition easy, retention effortless and engagement truly rewarding. Whether you're looking to grow your customer base or deepen customer relationships, our platform is designed to deliver results - no complexity, just plug and play tools that work.
           </p>
         </section>
   
         {/* ===============================================================
            Services  (with picker)
         =============================================================== */}
         <section className="services-section">
           <h2>Our Offerings</h2>
   
           {/* ---------- Picker ---------- */}
           <div className="service-picker">
             {SERVICES.map((service) => (
               <button
                 key={service.key}
                 className={`picker-item ${
                   service.key === activeKey ? "active" : ""
                 }`}
                 onClick={() => setActiveKey(service.key)}
               >
                 {service.label}
               </button>
             ))}
           </div>
   
           {/* ---------- Active Card ---------- */}
        <div className="service-card-home">
          <div className="service-content">
            {/* image */}
<div className="service-image">
  {activeService.mediaType === "video" ? (
    <video
      controls
      playsInline
      poster={activeService.poster}
      preload="metadata"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        display: "block",
      }}
    >
      <source src={activeService.media} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  ) : (
    <img
      src={activeService.media || activeService.img}
      alt={activeService.label}
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        display: "block",
      }}
    />
  )}
</div>

            {/* text */}
            <div className="service-description">
              <span className="service-category">
                {activeService.category}
              </span>

              <h3 className="service-title">
                {activeService.headline.map((line) => (
                  <span key={line}>{line}</span>
                ))}
              </h3>

              <ul className="service-features">
                {activeService.bullets.map((b) => (
                  <li key={b}>{b}</li>
                ))}
              </ul>

              {activeService.external ? (
                <a
                  href={activeService.link}
                  className="learn-more"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Learn More →
                </a>
              ) : (
                <Link to={activeService.link} className="learn-more">
                  Learn More →
                </Link>
              )}
            </div>
          </div>
        </div>
         </section>
   
         {/* ===============================================================
            Why Choose Us
         =============================================================== */}
        <section className="why-choose-us">
  <h2>Why Choose Us?</h2>

  <div className="benefits-grid">
    {/* card 1 */}
    <div className="benefit-card">
      <div className="benefit-icon">
        <img src="/images/seamless.svg" alt="Seamless Integration" />
      </div>
      <div className="benefit-text">
        <h3>Seamless Integration</h3>
        <p>Our solutions easily integrate into your existing systems.</p>
      </div>
    </div>

    {/* card 2 */}
    <div className="benefit-card">
      <div className="benefit-icon">
        <img src="/images/reliable.svg" alt="Reliable & Scalable" />
      </div>
      <div className="benefit-text">
        <h3>Reliable &amp; Scalable</h3>
        <p>Designed to handle businesses of all sizes, from startups to enterprises.</p>
      </div>
    </div>

    {/* card 3 */}
    <div className="benefit-card">
      <div className="benefit-icon">
        <img src="/images/cost.svg" alt="Cost-Effective" />
      </div>
      <div className="benefit-text">
        <h3>Cost-Effective</h3>
        <p>Maximize engagement while keeping costs low.</p>
      </div>
    </div>

    {/* card 4 */}
    <div className="benefit-card">
      <div className="benefit-icon">
        <img src="/images/centric.svg" alt="Customer-Centric" />
      </div>
      <div className="benefit-text">
        <h3>Customer-Centric</h3>
        <p>Focused on delivering the best user experience.</p>
      </div>
    </div>
  </div>
</section>

   
<section className="trusted-by">
  <p>Trusted By Our Clients</p>
  <div className="client-logos-carousel">
    <div className="client-logos">
      {/* — first pass of logos — */}
      <img src="/images/buupasscolor2.png" alt="Buupass logo" />
      <img src="/images/centurioncolor2.png" alt="Centurion logo" />
      <img src="/images/cheerscolor2.png" alt="Cheers logo" />
      <img src="/images/kenbrightcolor2.png" alt="Kenbright logo" />
      <img src="/images/onmobilecolor.png" alt="OnMobile logo" />
      <img src="/images/phoneplacecolor2.png" alt="Phone Place logo" />
      <img src="/images/samsungcolor2.png" alt="Samsung logo" />
      <img src="/images/sunking.png" alt="Sunking logo" />
      <img src="/images/knk.jpg" alt="KNK logo" />
      <img src="/images/lisha.jpg" alt="Lisha logo" />

      {/* — duplicate the exact same seven logos **for seamless looping** — */}
      <img src="/images/buupasscolor2.png" alt="" aria-hidden="true" />
      <img src="/images/centurioncolor2.png" alt="" aria-hidden="true" />
      <img src="/images/cheerscolor2.png" alt="" aria-hidden="true" />
      <img src="/images/kenbrightcolor2.png" alt="" aria-hidden="true" />
      <img src="/images/onmobilecolor2.png" alt="" aria-hidden="true" />
      <img src="/images/phoneplacecolor2.png" alt="" aria-hidden="true" />
      <img src="/images/samsungcolor2.png" alt="" aria-hidden="true" />
      <img src="/images/sunking.png" alt="" aria-hidden="true"/>
      <img src="/images/knk.jpg" alt="" aria-hidden="true"/>
      <img src="/images/lisha.jpg" alt="" aria-hidden="true"/>
    </div>
  </div>
</section>

   
       </div>
     );
   };
   
   export default Homepage;
